export default [
  {
    produktlinie: "001",
    tarifNummer: 0,
    tarifBeschreibung: "Einfach und Gut",
    tarifFarbe: "#e7eef2",
  },
  {
    produktlinie: "002",
    tarifNummer: 1,
    tarifBeschreibung: "Meistgewählt",
    tarifFarbe: "#9ad0b7",
  },
  {
    produktlinie: "003",
    tarifNummer: 2,
    tarifBeschreibung: "Unser bester Schutz",
    tarifFarbe: "#599F7C",
  },
];
